import ListaUnidadeDetalhes from "./ListaUnidadeDetalhes";

export default function UnidadeDetalhesForm() {
    return (
        <>
            <div className="pt-[50px] max-w-full">

                <h1 className="text-[45px] md:ml-5 max-sm:text-center">Detalhes da Unidade</h1>
                <div className="flex w-full justify-center">
                    <ListaUnidadeDetalhes />
                </div>
            </div>
        </>
    )
} 